import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useSalesNudges } from '@/hooks/use-sales-nudges';
import { newNudgePanelState } from '../nudge-draft';
import { PILL_BUTTON } from '../ui-chrome';
import type { NudgePanelState } from './nudge-panel';

interface CreateNudgeButtonProps {
	onCreate: (panel: NudgePanelState) => void;
}

/**
 * The page header's "Create Nudge". The page renders it only on the Nudges tab, so the nudges list
 * is fetched there and not on every other tab. One "Create Nudge" at a time: the empty state has
 * its own, so this one shows only once nudges exist.
 */
export const CreateNudgeButton = ({ onCreate }: CreateNudgeButtonProps) => {
	const { data: nudges = [] } = useSalesNudges();
	if (nudges.length === 0) return null;

	return (
		<Button type='button' onClick={() => onCreate(newNudgePanelState(nudges))} className={cn(PILL_BUTTON, 'gap-2')}>
			<Plus className='size-3.5' /> Create Nudge
		</Button>
	);
};
